var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoxbetPoker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: 31
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.985 4.265c.201.185.38.36.564.539 1.456 1.417 2.922 2.817 4.366 4.253a19.53 19.53 0 012.695 3.308c.641.958 1.129 2.006 1.446 3.109.253.816.316 1.677.185 2.52-.409 2.194-2.468 3.713-4.732 3.49-1.4-.14-2.479-.815-3.254-1.962a.45.45 0 00-.577-.203.315.315 0 00-.217.351 8.319 8.319 0 001.028 3.068A5.262 5.262 0 0015.96 25c.017.008.033.02.069.041H7.949a.312.312 0 01.056-.038 5.288 5.288 0 002.47-2.268 8.276 8.276 0 001.023-3.05.318.318 0 00-.224-.379.446.446 0 00-.527.152c-.094.126-.176.261-.276.382-1 1.22-2.3 1.777-3.89 1.64-1.954-.19-3.538-1.637-3.867-3.535a.787.787 0 01-.01-.135c0-.434-.027-.87 0-1.3.039-.376.113-.748.222-1.11.39-1.386 1.104-2.618 1.946-3.786A23.464 23.464 0 017.616 8.49l3.338-3.245c.31-.305.638-.61.957-.915l.074-.066h0zm-3.2 13.33l.023.017c.037-.02.076-.04.112-.063.992-.648 1.984-1.298 2.977-1.95a.155.155 0 01.104-.038c.039 0 .076.014.104.039 1.004.663 2.01 1.324 3.016 1.981.027.016.057.03.087.041l-.04-.131-1.13-3.133a.14.14 0 01-.011-.117.158.158 0 01.085-.09c.984-.64 1.966-1.285 2.949-1.928l.11-.076-.01-.028H13.364c-.084.008-.16-.043-.176-.118-.336-.94-.674-1.881-1.015-2.822A22.963 22.963 0 0012 8.718c-.025.056-.038.082-.048.109-.381 1.055-.76 2.11-1.138 3.164a.151.151 0 01-.067.1.184.184 0 01-.127.028H6.83v.03c.161.107.323.215.484.32l2.607 1.705c.057.038.09.067.063.145-.311.853-.618 1.708-.928 2.562-.093.236-.182.476-.27.715h0z",
    id: "svg_4",
    stroke: "null"
  }))))), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    strokeWidth: 0,
    x: 35.696,
    y: 25.856,
    id: "svg_5",
    fontFamily: "Proxima Nova',Arial, Helvetica, sans-serif;",
    fontSize: 24,
    fontWeight: 400,
    letterSpacing: 0.05,
    textAnchor: "start",
    xmlSpace: "preserve",
    stroke: "#fff",
    transform: "matrix(.77709 0 0 .72058 6.104 2.169)"
  }, "Poker"))));
}
SvgFoxbetPoker.displayName = 'FoxbetPoker';
export default SvgFoxbetPoker;